const toggleFilters = () => {
	const $triggers = $('.js-filters-togglers a');

	$triggers.on('click', function(event) {
		event.preventDefault();
		const $this = $(this);

		const target = $this.attr('href');
		$(target).toggleClass('is-active').slideToggle();

		$this.siblings().each(function(index, el) {
			const $el = $(el);
			const siblingsTarget = $el.attr('href');

			$(siblingsTarget).removeClass('is-active').slideUp();
		});
	});
};

toggleFilters();

const closeSelects = () => {
	const $closeBtn = $('.js-close-select');

	$closeBtn.on('click', function(event) {
		event.preventDefault();

		$(this).closest('.select').removeClass('is-active').slideUp();
	});
};

closeSelects();

const closeFilters = () => {
	const $closeBtn = $('.js-close-filters');

	$closeBtn.on('click', function(event) {
		event.preventDefault();

		$(this).closest('.product-filters').removeClass('is-active').slideUp();
	});
};

closeFilters();
